export const PricingTableData = [
  {
    feature: "Number of Artist",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00004 6.66665C9.4728 6.66665 10.6667 5.47274 10.6667 3.99998C10.6667 2.52722 9.4728 1.33331 8.00004 1.33331C6.52728 1.33331 5.33337 2.52722 5.33337 3.99998C5.33337 5.47274 6.52728 6.66665 8.00004 6.66665Z"
          stroke="#DDDDDD"
        />
        <path
          d="M12 6.00002C13.1046 6.00002 14 5.25383 14 4.33335C14 3.41288 13.1046 2.66669 12 2.66669"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
        <path
          d="M4 6.00002C2.89543 6.00002 2 5.25383 2 4.33335C2 3.41288 2.89543 2.66669 4 2.66669"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
        <path
          d="M8 14C10.2091 14 12 12.8061 12 11.3334C12 9.86059 10.2091 8.66669 8 8.66669C5.79086 8.66669 4 9.86059 4 11.3334C4 12.8061 5.79086 14 8 14Z"
          stroke="#DDDDDD"
        />
        <path
          d="M13.3334 12.6666C14.5028 12.4102 15.3334 11.7607 15.3334 11C15.3334 10.2392 14.5028 9.58978 13.3334 9.33331"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
        <path
          d="M2.66663 12.6666C1.49713 12.4102 0.666626 11.7607 0.666626 11C0.666626 10.2392 1.49713 9.58978 2.66663 9.33331"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
      </svg>
    ),
    independent: "1 Artist",
    pro: "2 Artists",
    label: "3-100 Artists"
  },
  {
    feature: "Upload Unlimited Songs",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M6.66704 5.33335C6.10987 4.91475 5.41725 4.66669 4.66671 4.66669C2.82576 4.66669 1.33337 6.15907 1.33337 8.00002C1.33337 9.84095 2.82576 11.3334 4.66671 11.3334C6.50765 11.3334 7.00004 10 8.00004 8.00002C9.00004 6.00002 9.49244 4.66669 11.3334 4.66669C13.1743 4.66669 14.6667 6.15907 14.6667 8.00002C14.6667 9.84095 13.1743 11.3334 11.3334 11.3334C10.5829 11.3334 9.89051 11.0852 9.33337 10.6667"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
      </svg>
    ),
    independent: "check",
    pro: "check",
    label: "check"
  },
  {
    feature: "Upload unlimited lyrics  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clip-path="url(#clip0_507_6430)">
          <path
            d="M0.948975 16V3.36478C0.948975 2.98643 1.08185 2.66437 1.3476 2.39862C1.61335 2.13287 1.93512 2 2.31291 2H10.5641C10.9413 2 11.2631 2.13287 11.5294 2.39862C11.7952 2.66437 11.928 2.98643 11.928 3.36478V3.57676C11.7631 3.65559 11.613 3.74567 11.4779 3.84702C11.3428 3.9478 11.2113 4.05759 11.0835 4.17639V3.36478C11.0835 3.21276 11.0348 3.08805 10.9374 2.99065C10.84 2.89325 10.715 2.84454 10.5624 2.84454H2.31291C2.16146 2.84454 2.03703 2.89325 1.93962 2.99065C1.84222 3.08805 1.79352 3.21276 1.79352 3.36478V13.9554L2.76981 12.9791H10.5641C10.7156 12.9791 10.84 12.9304 10.9374 12.833C11.0348 12.7356 11.0835 12.6111 11.0835 12.4597V9.95814C11.2113 10.0775 11.3428 10.1873 11.4779 10.2875C11.613 10.3889 11.7631 10.4789 11.928 10.5578V12.4597C11.928 12.8369 11.7952 13.1587 11.5294 13.425C11.2637 13.6907 10.9419 13.8236 10.5641 13.8236H3.12536L0.948975 16ZM3.90488 10.8677H6.43851V10.0232H3.90488V10.8677ZM3.90488 8.33408H8.97214V7.48953H3.90488V8.33408ZM3.90488 5.80045H8.97214V4.9559H3.90488V5.80045Z"
            fill="#DDDDDD"
          />
          <path
            d="M15.6633 3.68909C14.7304 3.68909 13.9742 2.93286 13.9742 2"
            stroke="#DDDDDD"
            stroke-width="1.01345"
            stroke-linecap="round"
          />
          <path
            d="M12.2853 8.75629C13.2181 8.75629 13.9744 8.00006 13.9744 7.0672C13.9744 6.13434 13.2181 5.37811 12.2853 5.37811C11.3524 5.37811 10.5962 6.13434 10.5962 7.0672C10.5962 8.00006 11.3524 8.75629 12.2853 8.75629Z"
            stroke="#DDDDDD"
            stroke-width="1.01345"
          />
          <path
            d="M13.9742 7.06726V4.53363V2"
            stroke="#DDDDDD"
            stroke-width="1.01345"
            stroke-linecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_507_6430">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    independent: "check",
    pro: "check",
    label: "check"
  },
  {
    feature: "Spotify verified check mark",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M6.39498 2.13349C6.80291 1.78587 7.00684 1.61205 7.22011 1.51013C7.71338 1.27437 8.28671 1.27437 8.77998 1.51013C8.99324 1.61205 9.19718 1.78587 9.60511 2.13349C9.76744 2.27185 9.84864 2.34103 9.93531 2.39914C10.134 2.53234 10.3572 2.62479 10.592 2.67113C10.6944 2.69135 10.8007 2.69983 11.0133 2.71679C11.5476 2.75943 11.8147 2.78075 12.0376 2.85947C12.553 3.04153 12.9585 3.44699 13.1406 3.96245C13.2192 4.18531 13.2406 4.45245 13.2832 4.9867C13.3002 5.19933 13.3087 5.30565 13.3289 5.40805C13.3752 5.64276 13.4677 5.86595 13.6009 6.06469C13.659 6.15139 13.7282 6.23256 13.8665 6.39491C14.2142 6.80285 14.388 7.00678 14.4899 7.22005C14.7256 7.71332 14.7256 8.28665 14.4899 8.77992C14.388 8.99318 14.2142 9.19712 13.8665 9.60505C13.7282 9.76738 13.659 9.84858 13.6009 9.93525C13.4677 10.134 13.3752 10.3572 13.3289 10.5919C13.3087 10.6943 13.3002 10.8006 13.2832 11.0132C13.2406 11.5475 13.2192 11.8146 13.1406 12.0375C12.9585 12.553 12.553 12.9584 12.0376 13.1405C11.8147 13.2192 11.5476 13.2405 11.0133 13.2832C10.8007 13.3001 10.6944 13.3086 10.592 13.3288C10.3572 13.3752 10.134 13.4676 9.93531 13.6008C9.84864 13.6589 9.76744 13.7281 9.60511 13.8664C9.19718 14.2141 8.99324 14.3879 8.77998 14.4898C8.28671 14.7256 7.71338 14.7256 7.22011 14.4898C7.00684 14.3879 6.80291 14.2141 6.39498 13.8664C6.23262 13.7281 6.15145 13.6589 6.06475 13.6008C5.86602 13.4676 5.64282 13.3752 5.40811 13.3288C5.30572 13.3086 5.1994 13.3001 4.98676 13.2832C4.4525 13.2405 4.18538 13.2192 3.96252 13.1405C3.44705 12.9584 3.0416 12.553 2.85953 12.0375C2.78081 11.8146 2.7595 11.5475 2.71686 11.0132C2.69989 10.8006 2.69141 10.6943 2.67119 10.5919C2.62485 10.3572 2.5324 10.134 2.3992 9.93525C2.3411 9.84858 2.27192 9.76738 2.13356 9.60505C1.78593 9.19712 1.61212 8.99318 1.51019 8.77992C1.27444 8.28665 1.27444 7.71332 1.51019 7.22005C1.61212 7.00678 1.78593 6.80285 2.13356 6.39491C2.27192 6.23256 2.3411 6.15139 2.3992 6.06469C2.5324 5.86595 2.62485 5.64276 2.67119 5.40805C2.69141 5.30565 2.69989 5.19933 2.71686 4.9867C2.7595 4.45245 2.78081 4.18531 2.85953 3.96245C3.0416 3.44699 3.44705 3.04153 3.96252 2.85947C4.18538 2.78075 4.45251 2.75943 4.98676 2.71679C5.1994 2.69983 5.30572 2.69135 5.40811 2.67113C5.64282 2.62479 5.86602 2.53234 6.06475 2.39914C6.15145 2.34103 6.23262 2.27185 6.39498 2.13349Z"
          stroke="#DDDDDD"
        />
        <path
          d="M5.66663 8.33331L6.99996 9.66665L10.3333 6.33331"
          stroke="#DDDDDD"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    independent: "check",
    pro: "check",
    label: "check"
  },
  {
    feature: "Create royalty splits",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 6C6.8954 6 6 5.10457 6 4C6 2.89543 6.8954 2 8 2C9.1046 2 10 2.89543 10 4C10 5.10457 9.1046 6 8 6Z"
          stroke="#DDDDDD"
          stroke-width="1.2"
        />
        <path
          d="M3.66638 14C2.56182 14 1.66638 13.1046 1.66638 12C1.66638 10.8954 2.56182 10 3.66638 10C4.77095 10 5.66638 10.8954 5.66638 12C5.66638 13.1046 4.77095 14 3.66638 14Z"
          stroke="#DDDDDD"
          stroke-width="1.2"
        />
        <path
          d="M12.3336 14C11.229 14 10.3336 13.1046 10.3336 12C10.3336 10.8954 11.229 10 12.3336 10C13.4382 10 14.3336 10.8954 14.3336 12C14.3336 13.1046 13.4382 14 12.3336 14Z"
          stroke="#DDDDDD"
          stroke-width="1.2"
        />
        <path
          d="M13.333 8.66681C13.333 7.07388 12.6347 5.64407 11.5274 4.66681M2.66638 8.66681C2.66638 7.07388 3.36473 5.64407 4.47197 4.66681M6.66638 13.8321C7.09252 13.9418 7.53932 14.0001 7.99972 14.0001C8.46012 14.0001 8.90692 13.9418 9.33305 13.8321"
          stroke="#DDDDDD"
          stroke-width="1.2"
          stroke-linecap="round"
        />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: "Access to free tools ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M1.66663 4.33335C1.66663 3.07627 1.66663 2.44773 2.05715 2.05721C2.44767 1.66669 3.07621 1.66669 4.33329 1.66669C5.59037 1.66669 6.21891 1.66669 6.60943 2.05721C6.99996 2.44773 6.99996 3.07627 6.99996 4.33335C6.99996 5.59043 6.99996 6.21897 6.60943 6.60949C6.21891 7.00002 5.59037 7.00002 4.33329 7.00002C3.07621 7.00002 2.44767 7.00002 2.05715 6.60949C1.66663 6.21897 1.66663 5.59043 1.66663 4.33335Z"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
        <path
          d="M9 11.6667C9 10.4096 9 9.78107 9.39053 9.39053C9.78107 9 10.4096 9 11.6667 9C12.9237 9 13.5523 9 13.9428 9.39053C14.3333 9.78107 14.3333 10.4096 14.3333 11.6667C14.3333 12.9237 14.3333 13.5523 13.9428 13.9428C13.5523 14.3333 12.9237 14.3333 11.6667 14.3333C10.4096 14.3333 9.78107 14.3333 9.39053 13.9428C9 13.5523 9 12.9237 9 11.6667Z"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
        <path
          d="M1.66663 11.6667C1.66663 10.4096 1.66663 9.78107 2.05715 9.39053C2.44767 9 3.07621 9 4.33329 9C5.59037 9 6.21891 9 6.60943 9.39053C6.99996 9.78107 6.99996 10.4096 6.99996 11.6667C6.99996 12.9237 6.99996 13.5523 6.60943 13.9428C6.21891 14.3333 5.59037 14.3333 4.33329 14.3333C3.07621 14.3333 2.44767 14.3333 2.05715 13.9428C1.66663 13.5523 1.66663 12.9237 1.66663 11.6667Z"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
        <path
          d="M9 4.33335C9 3.07627 9 2.44773 9.39053 2.05721C9.78107 1.66669 10.4096 1.66669 11.6667 1.66669C12.9237 1.66669 13.5523 1.66669 13.9428 2.05721C14.3333 2.44773 14.3333 3.07627 14.3333 4.33335C14.3333 5.59043 14.3333 6.21897 13.9428 6.60949C13.5523 7.00002 12.9237 7.00002 11.6667 7.00002C10.4096 7.00002 9.78107 7.00002 9.39053 6.60949C9 6.21897 9 5.59043 9 4.33335Z"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: " Sync lyrics in Apple Music  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M4.66638 5.33333C4.66638 3.49239 6.15877 2 7.99971 2C9.84065 2 11.333 3.49239 11.333 5.33333V7.33333C11.333 9.17427 9.84065 10.6667 7.99971 10.6667C6.15877 10.6667 4.66638 9.17427 4.66638 7.33333V5.33333Z"
          stroke="#DDDDDD"
          stroke-width="1.2"
        />
        <path
          d="M8.66638 5.33319H11.333"
          stroke="#DDDDDD"
          stroke-width="1.2"
          stroke-linecap="round"
        />
        <path
          d="M8.66638 7.33319H11.333"
          stroke="#DDDDDD"
          stroke-width="1.2"
          stroke-linecap="round"
        />
        <path
          d="M13.333 6.66681V7.33348C13.333 10.279 10.9452 12.6668 7.99972 12.6668C5.0542 12.6668 2.66638 10.279 2.66638 7.33348V6.66681"
          stroke="#DDDDDD"
          stroke-width="1.2"
          stroke-linecap="round"
        />
        <path
          d="M8 12.6668V14.6668"
          stroke="#DDDDDD"
          stroke-width="1.2"
          stroke-linecap="round"
        />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: "Daily streaming stats  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M14.6667 14.6666H8.00004C4.85734 14.6666 3.28599 14.6666 2.30969 13.6903C1.33337 12.714 1.33337 11.1426 1.33337 7.99998V1.33331"
          stroke="#DDDDDD"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M12.6668 4.66669L10.5881 7.28429C10.2697 7.68522 10.1105 7.88575 9.92773 7.98342C9.64667 8.13369 9.31087 8.14095 9.0236 8.00309C8.83673 7.91342 8.669 7.72009 8.33347 7.33335C7.99787 6.94662 7.83013 6.75329 7.64327 6.66359C7.356 6.52572 7.0202 6.53302 6.7392 6.68322C6.55641 6.78095 6.3972 6.98142 6.07879 7.38235L4 10"
          stroke="#DDDDDD"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: "Customize Label Name  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
          stroke="#DDDDDD"
        />
        <path
          d="M14.6338 8.66698C14.2993 12.0359 11.4569 14.667 8.00004 14.667C4.31814 14.667 1.33337 11.6822 1.33337 8.00031C1.33337 4.54343 3.96449 1.70106 7.33337 1.36658"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
        <path
          d="M10 7.99951V1.63806C12.0734 2.28927 13.7103 3.92615 14.3615 5.99953"
          stroke="#DDDDDD"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: "Customize release date  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M1.33337 7.99996C1.33337 5.4858 1.33337 4.22873 2.11442 3.44767C2.89547 2.66663 4.15255 2.66663 6.66671 2.66663H9.33337C11.8475 2.66663 13.1046 2.66663 13.8856 3.44767C14.6667 4.22873 14.6667 5.4858 14.6667 7.99996V9.33329C14.6667 11.8474 14.6667 13.1046 13.8856 13.8856C13.1046 14.6666 11.8475 14.6666 9.33337 14.6666H6.66671C4.15255 14.6666 2.89547 14.6666 2.11442 13.8856C1.33337 13.1046 1.33337 11.8474 1.33337 9.33329V7.99996Z"
          stroke="#F5F5F5"
        />
        <path
          d="M12 10.6667H10.6667M10.6667 10.6667H9.33337M10.6667 10.6667V9.33337M10.6667 10.6667V12"
          stroke="#F5F5F5"
          stroke-linecap="round"
        />
        <path
          d="M4.66663 2.66663V1.66663"
          stroke="#F5F5F5"
          stroke-linecap="round"
        />
        <path
          d="M11.3334 2.66663V1.66663"
          stroke="#F5F5F5"
          stroke-linecap="round"
        />
        <path d="M1.66663 6H14.3333" stroke="#F5F5F5" stroke-linecap="round" />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: "Customize iTunes pricing  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M8.00004 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00004C14.6667 4.31814 11.6819 1.33337 8.00004 1.33337C4.31814 1.33337 1.33337 4.31814 1.33337 8.00004C1.33337 11.6819 4.31814 14.6667 8.00004 14.6667Z"
          stroke="#DDDDDD"
        />
        <path d="M8 4V12" stroke="#DDDDDD" stroke-linecap="round" />
        <path
          d="M10 6.33329C10 5.41282 9.1046 4.66663 8 4.66663C6.8954 4.66663 6 5.41282 6 6.33329C6 7.25376 6.8954 7.99996 8 7.99996C9.1046 7.99996 10 8.74616 10 9.66663C10 10.5871 9.1046 11.3333 8 11.3333C6.8954 11.3333 6 10.5871 6 9.66663"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
      </svg>
    ),
    independent: "",
    pro: "check",
    label: "check"
  },
  {
    feature: "1TB instant file sharing  ",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M9.33337 14.1667H6.66671V15.1667H9.33337V14.1667ZM1.83337 9.33341V6.66674H0.833374V9.33341H1.83337ZM14.1667 9.04201V9.33341H15.1667V9.04201H14.1667ZM9.92751 3.07415L12.5667 5.44942L13.2356 4.70612L10.5965 2.33086L9.92751 3.07415ZM15.1667 9.04201C15.1667 7.91641 15.1768 7.20374 14.8928 6.56605L13.9793 6.97287C14.1566 7.37107 14.1667 7.82807 14.1667 9.04201H15.1667ZM12.5667 5.44942C13.469 6.26147 13.802 6.57473 13.9793 6.97287L14.8928 6.56605C14.6088 5.92835 14.0723 5.45909 13.2356 4.70612L12.5667 5.44942ZM6.68657 1.83341C7.74111 1.83341 8.13904 1.84113 8.49371 1.97723L8.85197 1.04361C8.28411 0.825688 7.66538 0.833408 6.68657 0.833408V1.83341ZM10.5965 2.33086C9.87251 1.67926 9.41984 1.2615 8.85197 1.04361L8.49371 1.97723C8.84851 2.11336 9.14771 2.37231 9.92751 3.07415L10.5965 2.33086ZM6.66671 14.1667C5.39549 14.1667 4.49238 14.1657 3.80727 14.0735C3.13655 13.9834 2.75011 13.8143 2.46797 13.5321L1.76087 14.2393C2.25978 14.7381 2.89241 14.9595 3.67403 15.0647C4.44125 15.1678 5.42376 15.1667 6.66671 15.1667V14.1667ZM0.833374 9.33341C0.833374 10.5763 0.832314 11.5589 0.935461 12.3261C1.04055 13.1077 1.26196 13.7403 1.76087 14.2393L2.46797 13.5321C2.18583 13.25 2.01672 12.8635 1.92655 12.1929C1.83443 11.5077 1.83337 10.6046 1.83337 9.33341H0.833374ZM9.33337 15.1667C10.5763 15.1667 11.5588 15.1678 12.326 15.0647C13.1076 14.9595 13.7403 14.7381 14.2392 14.2393L13.5321 13.5321C13.25 13.8143 12.8635 13.9834 12.1928 14.0735C11.5077 14.1657 10.6046 14.1667 9.33337 14.1667V15.1667ZM14.1667 9.33341C14.1667 10.6046 14.1656 11.5077 14.0735 12.1929C13.9834 12.8635 13.8142 13.25 13.5321 13.5321L14.2392 14.2393C14.7381 13.7403 14.9595 13.1077 15.0646 12.3261C15.1678 11.5589 15.1667 10.5763 15.1667 9.33341H14.1667ZM1.83337 6.66674C1.83337 5.39553 1.83443 4.49241 1.92655 3.80731C2.01672 3.13658 2.18583 2.75015 2.46797 2.46801L1.76087 1.7609C1.26196 2.25981 1.04055 2.89244 0.935461 3.67406C0.832314 4.44129 0.833374 5.42379 0.833374 6.66674H1.83337ZM6.68657 0.833408C5.43696 0.833408 4.44965 0.832354 3.67929 0.935454C2.89492 1.04043 2.26017 1.26161 1.76087 1.7609L2.46797 2.46801C2.74973 2.18626 3.13735 2.01691 3.81194 1.92662C4.50054 1.83446 5.40878 1.83341 6.68657 1.83341V0.833408Z"
          fill="#DDDDDD"
        />
        <path
          d="M8.66663 1.66663V3.33329C8.66663 4.90464 8.66663 5.69031 9.15476 6.17847C9.64296 6.66663 10.4286 6.66663 12 6.66663H14.6666"
          stroke="#DDDDDD"
        />
        <path
          d="M5.66671 12.3333V9M5.66671 9L4.33337 10.25M5.66671 9L7.00004 10.25"
          stroke="#DDDDDD"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    independent: "",
    pro: "",
    label: "check"
  },
  {
    feature: "Monitor your music on Spotify and Apple Music",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.33337 5.33337C3.33337 3.44775 3.33337 2.50495 3.91916 1.91916C4.50495 1.33337 5.44775 1.33337 7.33337 1.33337H8.66671C10.5523 1.33337 11.4951 1.33337 12.0809 1.91916C12.6667 2.50495 12.6667 3.44775 12.6667 5.33337V10.6667C12.6667 12.5523 12.6667 13.4951 12.0809 14.0809C11.4951 14.6667 10.5523 14.6667 8.66671 14.6667H7.33337C5.44775 14.6667 4.50495 14.6667 3.91916 14.0809C3.33337 13.4951 3.33337 12.5523 3.33337 10.6667V5.33337Z"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
        <path
          d="M12.6666 13C12.9763 13 13.1312 13 13.2607 12.9795C13.9738 12.8665 14.5332 12.3072 14.6461 11.5941C14.6666 11.4645 14.6666 11.3097 14.6666 11V5C14.6666 4.69033 14.6666 4.5355 14.6461 4.40594C14.5332 3.69279 13.9738 3.13347 13.2607 3.02052C13.1312 3 12.9763 3 12.6666 3"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
        <path
          d="M8.66663 9.33337V7.33337V5.33337"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
        <path
          d="M7.33333 10.6667C8.06971 10.6667 8.66667 10.0697 8.66667 9.33333C8.66667 8.59695 8.06971 8 7.33333 8C6.59695 8 6 8.59695 6 9.33333C6 10.0697 6.59695 10.6667 7.33333 10.6667Z"
          stroke="#DDDDDD"
        />
        <path
          d="M9.99996 6.66671C9.26356 6.66671 8.66663 6.06975 8.66663 5.33337"
          stroke="#DDDDDD"
          stroke-linecap="round"
        />
        <path
          d="M3.33337 13C3.02371 13 2.86887 13 2.73931 12.9795C2.02616 12.8665 1.46685 12.3072 1.35389 11.5941C1.33337 11.4645 1.33337 11.3097 1.33337 11V5C1.33337 4.69033 1.33337 4.5355 1.35389 4.40594C1.46685 3.69279 2.02616 3.13347 2.73931 3.02052C2.86887 3 3.02371 3 3.33337 3"
          stroke="#DDDDDD"
          stroke-width="1.5"
        />
      </svg>
    ),
    independent: "",
    pro: "",
    label: "check"
  }
];
